export default __webpack_public_path__ + "static/media/Rayon.a8f1bfc9.jpg";